import { CLUSTER_OTHER_ID } from '../constants.js';
import { RootNode } from '../types/guards/node-guards.js';
import type { HighlightingMap } from '../types/internal.js';
import type { NameAccessor } from '../types/treemap.js';
import { getNodeNames } from './get-nodes-names.js';

const getAggregatedClusterLeafNames = (map: HighlightingMap) => {
  const aggregatedClusterLeafNames = new Set<string>(map[CLUSTER_OTHER_ID]);

  map[CLUSTER_OTHER_ID].forEach((cluster) =>
    map[`cluster-${cluster}`].forEach((leaf) =>
      aggregatedClusterLeafNames.add(leaf),
    ),
  );
  return aggregatedClusterLeafNames;
};

export const getHighlightingMap = (
  data: RootNode,
  nameAccessor: NameAccessor | undefined,
): HighlightingMap => {
  const map: HighlightingMap = {};
  data.children.forEach((cluster) => {
    const clusterId = cluster.id;
    const clusterName = cluster.name;

    map[clusterId] = getNodeNames(cluster, nameAccessor, clusterName);

    cluster.children?.forEach((leaf) => {
      const leafId = leaf.id;
      if (leafId === CLUSTER_OTHER_ID) {
        return;
      }
      map[leafId] = getNodeNames(leaf, nameAccessor, clusterName);
    });
  });

  if (map[CLUSTER_OTHER_ID]) {
    map[CLUSTER_OTHER_ID] = getAggregatedClusterLeafNames(map);
  }

  return map;
};
